var map = {
	"./api.png": "eaf8",
	"./document.png": "687d",
	"./facebook.png": "9056",
	"./news.png": "cdbb",
	"./toutiao.png": "b59c",
	"./twitter.png": "070f",
	"./weibo.png": "6444",
	"./youtube.png": "8287"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f5c";